import { useSyncExternalStore } from 'react';

import {
  type HeaderSelection,
  getHeaderSelection,
  subscribeHeaderSelection,
} from '@/selection/headerSelection';

const snapshot = (): HeaderSelection => getHeaderSelection();

/**
 * The current header selection for React (UI state plan, step A): header
 * brand, header partner and the global filter of the ACTIVE role assignment.
 * Re-renders when one of them (or the active assignment) changes.
 *
 * The value is read-only. It is changed through `useGlobalFilters()`
 * (`setHeaderBrand`, `setHeaderProperty`: they run the page's leave guard)
 * or, outside React, through selection/headerSelection.ts.
 */
export const useHeaderSelection = (): HeaderSelection =>
  useSyncExternalStore(subscribeHeaderSelection, snapshot, snapshot);
